(function () {
  'use strict';
  var source = document.currentScript;
  var builder = document.getElementById('product-builder');
  if (!source || !builder || builder.dataset.cvBootStarted) return;
  builder.dataset.cvBootStarted = 'true';
  var studio = builder.closest('[data-cv-cpb-studio]');
  var status = studio.querySelector('[data-cv-product-status]');
  var retry = studio.querySelector('[data-cv-product-retry]');
  var loader = studio.querySelector('[data-cv-cpb-loader]');

  var scriptsDone = false;
  var progress = studio.querySelector('[data-cv-load-progress]');
  var percent = studio.querySelector('[data-cv-load-percent]');
  var lastProgress = 0;
  function setProgress(value, label) {
    lastProgress = Math.max(lastProgress, value);
    studio.style.setProperty('--cv-load-progress', lastProgress);
    if (progress) {
      progress.setAttribute('aria-valuenow', lastProgress);
      progress.setAttribute('aria-valuetext', lastProgress + '% · ' + label);
    }
    if (percent) percent.textContent = lastProgress + '%';
  }
  setProgress(0, 'Preparando archivos');

  function controlsReady() {
    return Boolean(builder.querySelector('.cpb-panels-container .cpb-product-panel'));
  }
  function showFailure() {
    if (builder.dataset.cvBootState === 'ready') return;
    if (loader) loader.classList.add('is-hidden');
    if (status) status.textContent = 'No se pudieron cargar las opciones de personalización. Vuelve a intentarlo.';
    if (retry) retry.hidden = false;
    builder.dataset.cvBootState = 'failed';
  }
  function load(url) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = function () { reject(new Error('CPB dependency unavailable')); };
      document.head.appendChild(script);
    });
  }

  var urls = [
    'https://cdn.shopify.com/s/assets/external/app.js',
    'https://cdn.thecustomproductbuilder.com/dist/latest/custom-product-builder.js',
    'https://cdn.thecustomproductbuilder.com/dist/latest/customizer-theme-main.js',
    source.dataset.cvLaserSrc,
    source.dataset.cvStudioSrc
  ];
  // Download dependencies concurrently, but execute them in their required order.
  urls.forEach(function (url) {
    var hint = document.createElement('link');
    hint.rel = 'preload'; hint.as = 'script'; hint.href = url;
    document.head.appendChild(hint);
  });
  var watchdog = window.setTimeout(showFailure, 30000);
  var chain = Promise.resolve();
  urls.forEach(function (url, index) {
    chain = chain.then(function () { return load(url); }).then(function () {
      setProgress((index + 1) * 14, 'Archivos cargados ' + (index + 1) + '/5');
    });
  });
  chain.then(function () { scriptsDone = true; checkReady(); }).catch(showFailure);

  function checkReady() {
    if (!scriptsDone || !controlsReady()) return;
    setProgress(85, 'Opciones listas');
    var preview = builder.querySelector('.cpb-preview-layers');
    var canvas = preview && preview.querySelector('canvas');
    if (!canvas || !canvas.width || !canvas.height) return;
    var images = Array.prototype.slice.call(preview.querySelectorAll('img'));
    if (images.some(function (img) { return !img.complete || !img.naturalWidth; })) return;
    setProgress(100, 'Vista previa lista');
    window.clearTimeout(watchdog);
    if (retry) retry.hidden = true;
    builder.dataset.cvBootState = 'ready';
    observer.disconnect();
    builder.removeEventListener('load', checkReady, true);
  }

  var observer = new MutationObserver(checkReady);
  observer.observe(builder, { childList: true, subtree: true, attributes: true, attributeFilter: ['width', 'height'] });
  builder.addEventListener('load', checkReady, true);
})();
